import userData from "toolkit/data/userData";
import { FooterSection } from "./FooterSection";

export const Footer = () => {
  const { footer } = userData;
  return (
    <div className="footer-container p-v-5" id="connect">
      {footer?.map((footerEl) => (
        <FooterSection key={footerEl._id} footerEl={footerEl} />
      ))}
    </div>
  );
};
